import React, { createContext, useContext, useEffect, useState } from 'react'
import getPermission from '@fs/zion-permissions'
import { useTranslation } from 'react-i18next'
import { NoticeLoading } from '@fs/zion-icon'
import { getCenterDirectorPermissions, getEditingPermissions, getCenterOutageMessage } from '../service/api'
import AlertBannerContext from './AlertBannerContext'

const AdminContext = createContext(() => {})

const permissionContext = 'DirectorsPortal'
const supportPermission = 'DirectorsPortalCenterSupportStaffPermission'
const deletePermission = 'DirectorsPortalDeletePermission'
const adminPermission = 'DirectorsPortalAdminPermission'

const retrievePermission = (permission, results) => {
  const foundPermission = results?.roleResults.find((result) => {
    return result.roleName === permission.replace('Permission', 'Role')
  })
  if (!foundPermission) return false
  return foundPermission.activatorResults[0].success
}
const processPermissions = (permissionsResults) => {
  const permissions = {}
  permissions.isAdmin = retrievePermission(adminPermission, permissionsResults)
  permissions.isSupport = retrievePermission(supportPermission, permissionsResults)
  permissions.canDelete = retrievePermission(deletePermission, permissionsResults)
  return permissions
}

export default function CenterAdminProvider({ children }) {
  const [state, setState] = useState({})
  const [t] = useTranslation()
  const { setOpen, setAlertBannerProps } = useContext(AlertBannerContext)
  // Initialize Hours Data
  useEffect(() => {
    let cancelled = false
    async function fetchPermissionsData() {
      !cancelled && setState({ loading: true })
      try {
        const promises = [
          getCenterOutageMessage(),
          getCenterDirectorPermissions(),
          getEditingPermissions(),
          getPermission([adminPermission, supportPermission, deletePermission], permissionContext),
        ]
        const [outageMessage, directorPermissions, editingPermissions, adminPermissions] = await Promise.all(promises)
        const permissions = processPermissions(adminPermissions)
        if (!cancelled) {
          setState({
            ...permissions,
            canEdit: editingPermissions?.data,
            isDirector: directorPermissions?.data,
            loading: false,
            outageMessage: outageMessage?.data?.globalMessage,
          })
        }
      } catch (e) {
        // console.log(e)
      }
    }
    fetchPermissionsData()
    return () => {
      cancelled = true
    }
  }, [])

  useEffect(() => {
    if (state.outageMessage && state.editingPermissions) {
      setAlertBannerProps({
        type: 'maintenance',
        message: state.outageMessage,
        dismissText: t('common-ui:dismiss.action', 'Dismiss'),
        onConfirm(closeBanner) {
          closeBanner()
        },
      })
      setOpen(true)
    }
  }, [t, setAlertBannerProps, state.editingPermissions, state.outageMessage, setOpen])
  return (
    <AdminContext.Provider value={state}>
      {state.loading && <NoticeLoading />}
      {!state.loading && children}
    </AdminContext.Provider>
  )
}

export const useAdminContext = () => useContext(AdminContext)
